import Swal from 'sweetalert2';
import {
    SEE_CONTACT_REQUESTS,
    SEE_CONTACT_LIST,
    IS_LOADING_CONTACTS_REQUEST,
    IS_LOADING_CONTACTS,
    ACCEPT_CONTACT_REQUEST,
    CANCEL_CONTACT_REQUEST,
    IS_LOADING_CONTACT_LIST,
    DELETE_CONTACT,
    LOAD_CONTACT_RELATION_BETWEEN,
    CHANGE_CONTACT_RELATION_BETWEEN,
    GET_PROFESSIONAL_LIST,
    IS_LOADING_GET_PROFESSIONAL_LIST
} from './types'
import inMemoryJWT from '../auth/inMemoryJwt';
import {
    urlServer
} from '../config/GlobalConstant'
import localStorage from '../utils/hooks/useLocalStorage';

//contacts of professional actions (CRUD)
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})

export const getProfessionalUsers = () => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_PROFESSIONAL_LIST
    })
    await fetch(`${urlServer}api/professional`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },

        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_PROFESSIONAL_LIST,
                payload: respJson.data
            })
        })
        .catch(error => {
            console.log()
        })

}

export const addContact = (secondID, dataCurrentRelation) => async dispatch => {
    const accessToken = inMemoryJWT.getToken()

    await fetch(`${urlServer}api/social/professional`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                firstID: localStorage().getItem('professionalID'),
                secondID: secondID,
                type: 1
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud de contacto enviada'
                })
            }
            if (dataCurrentRelation) {
                dispatch({
                    type: LOAD_CONTACT_RELATION_BETWEEN
                })
                dispatch({
                    type: CHANGE_CONTACT_RELATION_BETWEEN,
                    payload: respJson.data.social
                })
            }
        })
        .catch(error => {
            console.log()
        })

}

export const seeContactsRequests = () => async dispatch => {
    dispatch({
        type: IS_LOADING_CONTACTS_REQUEST
    });
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/professional-get-requests`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                idUser: localStorage().getItem('professionalID'),
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: SEE_CONTACT_REQUESTS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}


export const acceptContactRequest = (id, dataCurrentRelation) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/professional`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                firstID: localStorage().getItem('professionalID'),
                secondID: id,
                type: 2
            })
        })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud aceptada'
                })
            }
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_CONTACTS_REQUEST
                });
                dispatch({
                    type: ACCEPT_CONTACT_REQUEST,
                    payload: id
                })
            } else {
                dispatch({
                    type: LOAD_CONTACT_RELATION_BETWEEN
                });
                dispatch({
                    type: CHANGE_CONTACT_RELATION_BETWEEN,
                    payload: respJson.data.social
                })
            }

        })
        .catch(error => {
            console.log()
        })

}

export const cancelContactRequest = (id, dataCurrentRelation) => async dispatch => {
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/professional`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                firstID: localStorage().getItem('professionalID'),
                secondID: id,
                type: 3
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_CONTACTS_REQUEST
                });
                dispatch({
                    type: CANCEL_CONTACT_REQUEST,
                    payload: id
                })
            } else {
                dispatch({
                    type: LOAD_CONTACT_RELATION_BETWEEN
                })
                dispatch({
                    type: CHANGE_CONTACT_RELATION_BETWEEN,
                    payload: respJson.data.social
                })
            }
        })
        .catch(error => {
            console.log()
        })

}

export const seeContactList = (idUser) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/professional-get-social`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                idUser: idUser,
                type: 1
            })
        })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_CONTACT_LIST
            });
            dispatch({
                type: SEE_CONTACT_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}

export const deleteContact = (id, dataCurrentRelation) => async dispatch => {
    console.log()
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/professional`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                firstID: localStorage().getItem('professionalID'),
                secondID: id,
                type: 4
            })
        })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Eliminado de contactos'
                })
            }

            dispatch({
                type: IS_LOADING_CONTACT_LIST
            });
            dispatch({
                type: DELETE_CONTACT,
                payload: id
            })

        })
        .catch(error => {
            console.log()
        })

}